import { FC, PropsWithChildren } from 'react'
import Link from 'next/link'
import { sanitizeUrl } from '@/utils'
import { Avatar2 } from '@components-v2/atoms/Avatar2'
import { VerifiedTick } from '@components-v2/atoms/VerifiedTick'
import styles from './index.module.scss'

type Props = {
  src: string
  href?: string
  withVerifiedTick?: boolean
}

export const AvatarContentFullCard: FC<PropsWithChildren<Props>> = ({
  src,
  href,
  withVerifiedTick = false,
  children,
}) => {
  return (
    <Link href={sanitizeUrl(href)}>
      <a className={styles.container} target='_blank'>
        <div className={styles.card}>
          <div className={styles.left}>
            <div className={styles.avatar}>
              <Avatar2 src={src} size='xxl' />
              {withVerifiedTick && (
                <div className={styles.verifiedTick}>
                  <VerifiedTick size='md' />
                </div>
              )}
            </div>
          </div>
          <div className={styles.right}>{children}</div>
        </div>
      </a>
    </Link>
  )
}
